import React, { FC } from 'react';

// solid glyphs for every piece; color is conveyed by fill + outline
const GLYPHS: Record<string, string> = {
  k: '♚',
  q: '♛',
  r: '♜',
  b: '♝',
  n: '♞',
  p: '♟'
};

interface Props {
  type: string; // 'p' | 'n' | 'b' | 'r' | 'q' | 'k'
  color: 'w' | 'b';
}

const ChessPiece: FC<Props> = ({ type, color }) => (
  <svg width="86%" height="86%" viewBox="0 0 100 100" style={{ display: 'block', pointerEvents: 'none' }}>
    <text
      x="50"
      y="80"
      textAnchor="middle"
      fontSize="86"
      fill={color === 'w' ? '#fafafa' : '#202020'}
      stroke={color === 'w' ? '#202020' : '#000'}
      strokeWidth="2"
      paintOrder="stroke">
      {GLYPHS[type]}
    </text>
  </svg>
);

export default ChessPiece;
